import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-38d00c7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "btn-mas"
}, null, -1))
const _hoisted_3 = { class: "redes" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-list",
  _mstvisible: "2"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-mas" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "btn-mas",
    class: "fa fa-cog"
  })
], -1))
const _hoisted_6 = {
  key: 0,
  class: "spin"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "general" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Crear Lote", -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Pre Lotes")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "medico"
}, "Médico:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Todos", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Todos ")
const _hoisted_16 = { class: "grid" }
const _hoisted_17 = { class: "gridlistadocumentos" }
const _hoisted_18 = { class: "table table-hover" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "mith" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Médico"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Cliente"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Cantidad"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite der" }, "Total")
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "t izq bold" }
const _hoisted_24 = { class: "t izq bold" }
const _hoisted_25 = { class: "bold der" }
const _hoisted_26 = { class: "bold der" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "bold izq bold" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_30 = { class: "bold der" }
const _hoisted_31 = { class: "bold der" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grid" })
], -1))
const _hoisted_33 = { class: "title" }
const _hoisted_34 = {
  key: 0,
  class: "form-group"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Reclamaciones En Lote")
], -1))
const _hoisted_36 = { class: "grid" }
const _hoisted_37 = { class: "gridlistadocumentos" }
const _hoisted_38 = { class: "table table-hover" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "mith" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Fecha"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Aseguradora"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Autorización"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Paciente"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Tipo Servicio"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite der" }, "Valor"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" })
], -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { style: {"cursor":"pointer"} }
const _hoisted_43 = { class: "t izq bold" }
const _hoisted_44 = { class: "t izq bold" }
const _hoisted_45 = { class: "t izq bold" }
const _hoisted_46 = { class: "bold" }
const _hoisted_47 = { class: "t izq bold" }
const _hoisted_48 = { class: "bold der" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "bold izq bold" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_56 = { class: "bold der" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_58 = {
  key: 1,
  class: "form-group"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Reclamaciones Fuera de Lote")
], -1))
const _hoisted_60 = { class: "grid" }
const _hoisted_61 = { class: "gridlistadocumentos" }
const _hoisted_62 = { class: "table table-hover" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "mith" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Fecha"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Autorización"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Paciente"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite der" }, "Valor"),
  /*#__PURE__*/_createElementVNode("th", { class: "cwhite" })
], -1))
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { style: {"cursor":"pointer"} }
const _hoisted_67 = { class: "t izq bold" }
const _hoisted_68 = { class: "t izq bold" }
const _hoisted_69 = { class: "bold" }
const _hoisted_70 = { class: "bold der" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "bold izq bold" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_76 = { class: "bold der" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_78 = { key: 2 }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "descServicio"
}, "Descripción:", -1))
const _hoisted_80 = {
  key: 3,
  class: "grid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "a yellow",
          to: "/documentoslot"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _hoisted_5
    ]),
    (_ctx.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", null, [
              _hoisted_13,
              _withDirectives(_createElementVNode("select", {
                id: "medico",
                type: "medico",
                class: "form-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.documento.medico) = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterLotes(_ctx.documento.medico)))
              }, [
                _hoisted_14,
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medicos, (medico, index) => {
                  return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(medico.emisor), 1))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.documento.medico]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("table", _hoisted_18, [
                  (this.totales.documentos2)
                    ? (_openBlock(), _createElementBlock("thead", _hoisted_19, _hoisted_21))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lotes, (lote, index) => {
                    return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                      _createElementVNode("tr", {
                        style: {"cursor":"pointer"},
                        onClick: _withModifiers(($event: any) => (_ctx.cargarReclamos(lote)), ["prevent"])
                      }, [
                        _createElementVNode("td", _hoisted_23, _toDisplayString(lote._id.medico), 1),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(lote._id.descCliente), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.formatNumber2(lote.count)), 1),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.formatNumber(lote.total)), 1)
                      ], 8, _hoisted_22)
                    ]))
                  }), 128)),
                  _createElementVNode("tbody", null, [
                    (this.totales.documentos2)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                          _createElementVNode("td", _hoisted_28, " Total: " + _toDisplayString(_ctx.formatNumber2(this.totales.documentos2)), 1),
                          _hoisted_29,
                          _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.formatNumber2(this.totales.sumaDocs)), 1),
                          _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.formatNumber(this.totales.reclamacion2)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_32,
          _createElementVNode("legend", null, [
            _createElementVNode("b", _hoisted_33, _toDisplayString(_ctx.documento.descCliente), 1)
          ]),
          (this.totales.documentos)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("table", _hoisted_38, [
                      (this.totales.documentos)
                        ? (_openBlock(), _createElementBlock("thead", _hoisted_39, _hoisted_41))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reclams, (reclam, index) => {
                        return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                          _createElementVNode("tr", _hoisted_42, [
                            _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatDate(reclam.fechaProceso)), 1),
                            _createElementVNode("td", _hoisted_44, _toDisplayString(reclam.aseguradora), 1),
                            _createElementVNode("td", _hoisted_45, _toDisplayString(reclam.autorizacion), 1),
                            _createElementVNode("td", _hoisted_46, _toDisplayString(reclam.nombreAfiliado), 1),
                            _createElementVNode("td", _hoisted_47, _toDisplayString(reclam.tipoServicio), 1),
                            _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.formatNumber(reclam.reclamacion)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("i", {
                                onClick: _withModifiers(($event: any) => (_ctx.deleteService(index, reclam)), ["prevent"]),
                                class: "fas fa-minus-circle redOption"
                              }, null, 8, _hoisted_49)
                            ])
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("tbody", null, [
                        (this.totales.documentos)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [
                              _createElementVNode("td", _hoisted_51, " Total: " + _toDisplayString(_ctx.formatNumber2(this.totales.documentos)), 1),
                              _hoisted_52,
                              _hoisted_53,
                              _hoisted_54,
                              _hoisted_55,
                              _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.formatNumber(this.totales.reclamacion)), 1),
                              _hoisted_57
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (this.totales.documentos3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("table", _hoisted_62, [
                      (this.totales.documentos3)
                        ? (_openBlock(), _createElementBlock("thead", _hoisted_63, _hoisted_65))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reclams2, (reclam, index) => {
                        return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                          _createElementVNode("tr", _hoisted_66, [
                            _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.formatDate(reclam.fechaProceso)), 1),
                            _createElementVNode("td", _hoisted_68, _toDisplayString(reclam.autorizacion), 1),
                            _createElementVNode("td", _hoisted_69, _toDisplayString(reclam.nombreAfiliado), 1),
                            _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.formatNumber(reclam.reclamacion)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("i", {
                                onClick: _withModifiers(($event: any) => (_ctx.addService(index, reclam)), ["prevent"]),
                                class: "fas fa-plus-circle greenOption"
                              }, null, 8, _hoisted_71)
                            ])
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("tbody", null, [
                        (this.totales.documentos)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_72, [
                              _createElementVNode("td", _hoisted_73, " Total: " + _toDisplayString(_ctx.formatNumber2(this.totales.documentos3)), 1),
                              _hoisted_74,
                              _hoisted_75,
                              _createElementVNode("td", _hoisted_76, _toDisplayString(_ctx.formatNumber(this.totales.reclamacion3)), 1),
                              _hoisted_77
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (this.totales.documentos)
            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                _hoisted_79,
                _withDirectives(_createElementVNode("input", {
                  id: "descServicio",
                  type: "descServicio",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.documento.descServicios) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.documento.descServicios]
                ])
              ]))
            : _createCommentVNode("", true),
          (this.totales.documentos)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "btn btn-info",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.saveDocumento2()), ["prevent"]))
                  }, " Generar Prefactura ")
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.saveDocumento()), ["prevent"]))
                  }, " Generar Factura ")
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.cargando]
    ])
  ], 64))
}